module.exports = __webpack_public_path__ + "img/ic_qrcode_youbute.d6bd4db.png";